import type { Event } from "@lezz/shared";
import { buildIcsContent, ICS_FILE_NAME } from "./calendar";

/**
 * Generates the event's `.ics` file and triggers a browser download.
 */
export async function openIcs(event: Event): Promise<void> {
  const blob = new Blob([buildIcsContent(event)], {
    type: "text/calendar;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = ICS_FILE_NAME;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
